import { MongoTeamId } from "@redotech/redo-ids-mongo";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { BackfillManualChannelSchema } from "./get-support-backfill-messages";

export const getSupportV2BackfillIntegrations = unaryRpc({
  name: "getSupportV2BackfillIntegrations" as const,
  input: z.object({ teamId: MongoTeamId.schema }),
  output: z.object({
    integrations: z.array(
      z.object({
        id: z.string(),
        channel: BackfillManualChannelSchema,
        identifier: z.string().optional(),
        available: z.boolean(),
        unavailableReason: z.string().optional(),
      }),
    ),
  }),
});

export type GetSupportV2BackfillIntegrationsOutput = z.infer<
  typeof getSupportV2BackfillIntegrations.output
>;
